// styles
import "./styles.scss";
import icon1 from "../../assets/images/icons/icon-work.svg";
import icon2 from "../../assets/images/icons/icon-breifcase.svg";
import icon3 from "../../assets/images/icons/icon-marketing.svg";
import icon4 from "../../assets/images/icons/icon-random.svg";
import PrimaryButton from "../primaryButton";
import scrollTo from "../../utils/scrollTo";

const items = [
  {
    icon: icon2,
    heading: "Effective PR",
    description:
      "Leveraging strategic PR with precision, we ensure consistent impact. Coupled with finely crafted content, your business message is reinforced and reiterated among outlets that matter",
  },
  {
    icon: icon1,
    heading: "Crisis Communication",
    description:
      "At Value 360 Communications, your reputation is our responsibility. Sail out of crises unscathed and unblemished with our tried-and-tested crisis management protocols",
  },
  {
    icon: icon3,
    heading: "Digital Marketing",
    description:
      "Integrated media agency to help brands succeed in the digital world. Proven results with White-hat SEO techniques, Social media management, ROI-driven performance marketing, Design & Development, and a lot more.",
  },
  {
    icon: icon4,
    heading: "Influencer Marketing",
    description:
      "In today’s day and age, influencer marketing is an indispensable tool in your arsenal. We simplify and streamline your influencer engagement efforts to deliver winning campaigns every time",
  },
];

function KeyOfferingSec({ label, heading }) {
  return (
    <>
      <div className="key-offering-container" id="services">
        <div className="container">
          <div className="heading-sec text-center">
            <h2 className="heading primary-text-color">{heading}</h2>
          </div>
          <div className="service-block">
            {items.map((item, index) => {
              return (
                <div className="item-box" key={item?.heading}>
                  <div className="icon-box">
                    <img className="icon" src={item.icon} alt="icon" />
                  </div>
                  <div className="service-heading secondary-text-color">
                    {item.heading}
                  </div>
                  <div className="service-desc secondary-text-color">
                    {item.description}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="know-more-btn-box">
            <PrimaryButton
              className="submit-btn"
              onClick={() => {
                scrollTo("nameFieldQueryForm");
              }}
              buttonName="Get a Quote"
              type="submit"
              disabled={false}
              // loader={loader}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default KeyOfferingSec;
